import { render, staticRenderFns } from "./CollaborationMemberManage.vue?vue&type=template&id=fa3a7780&scoped=true&"
import script from "./CollaborationMemberManage.vue?vue&type=script&lang=ts&"
export * from "./CollaborationMemberManage.vue?vue&type=script&lang=ts&"
import style0 from "./CollaborationMemberManage.vue?vue&type=style&index=0&id=fa3a7780&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3a7780",
  null
  
)

export default component.exports